// useage: trackData('Hello World');

const trackDataKey = 'TrackSessionData';
const trackConstDataKey = 'TrackSessionConstData';
const site = window.themeVariables.globalData.currentRegionKey || window.location.host.split('.')[0];
const signKey = '0a153ec8bc1f469d8a16abba0f8007be';

async function getDeviceInfo() {
  let deviceRegion = window.sessionStorage.getItem('deviceRegion');
  if (!deviceRegion) {
    const deviceRegionInfo = await fetch(
      window.Shopify.routes.root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        `&language[exclude]=${window.Shopify.language}`
    ).then((r) => r.json());
    deviceRegion = await window.Shopify?.customerPrivacy?.getRegion();
    if (deviceRegionInfo?.detected_values?.country?.handle) {
      deviceRegion = deviceRegionInfo.detected_values.country.handle;
    }
    if (deviceRegionInfo.suggestions && deviceRegionInfo.suggestions.length > 0) {
      let suggestion = deviceRegionInfo.suggestions[0]?.parts?.country?.handle;
      deviceRegion = suggestion;
    }
    window.sessionStorage.setItem('deviceRegion', deviceRegion);
  }
  console.log('deviceRegion: ', deviceRegion);
  return deviceRegion;
}

// 将获取区域的方法注册到全局，后续直接调用即可
window.getDeviceRegion = getDeviceInfo

// IP 地址
async function getIpAddress() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip || 'Unknown';
  } catch (error) {
    console.error('获取 IP 失败:', error);
    return 'Unknown';
  }
}

// 根据IP获取地区
async function getRegionByIp(ip) {
  if(!ip) {
    return '';
  }
  try {
    const ipRegionInfo = await fetch('https://ipwho.is/' + ip).then((r) => r.json());
    const country_code = ipRegionInfo?.country_code;
    console.log('country_code: ', country_code);
    return country_code;
  } catch (error) {
    console.error('getRegionByIp error:', error);
    return '';
  }
}
    
function getOrCreateSessionId(expiryMinutes = 30) {
  
  const stored = localStorage.getItem(trackDataKey);
  const now = Date.now();
  
  if (stored) {
    const sessionData = JSON.parse(stored);
    const expiryTime = sessionData.timestamp + expiryMinutes * 60 * 1000;
    
    // 检查是否过期
    if (now < expiryTime) {
      return sessionData.sessionId;
    } else {
      // 过期，清理并生成新的
      localStorage.removeItem(trackDataKey);
    }
  }
  
  // 生成新的会话 ID
  const sessionId = generateSessionId();
  localStorage.setItem(trackDataKey, JSON.stringify({
    sessionId,
    timestamp: now
  }));
  return sessionId;
}

async function getOrCreateTrackData(expiryMinutes = 30) {
  
  const stored = localStorage.getItem(trackConstDataKey);
  const now = Date.now();
  
  if (stored) {
    const sessionData = JSON.parse(stored);
    const expiryTime = sessionData.timestamp + expiryMinutes * 60 * 1000;
    
    // 检查是否过期
    if (now < expiryTime) {
      return sessionData.constData;
    } else {
      // 过期，清理并生成新的
      localStorage.removeItem(trackConstDataKey);
    }
  }
  
  // 生成新的会话 ID
  const sessionId = generateSessionId();
  // 并行获取异步数据
  const [ip, region] = await Promise.all([getIpAddress(), getDeviceInfo()]);
  const ipRegion = await getRegionByIp(ip);

  const constData = {
    "timestamp": now,
    "session_id": sessionId,
    "user_id": window.localStorage.getItem('customer_email') || '',
    "device_info": {
      "ip": ip,
      "region": ipRegion || region,
      "platform": getPlatform(),
      "os": getOS(),
      "browser": getBrowser(),
      "screen": getScreenResolution(),
    },
    "site": site
  }
  localStorage.setItem(trackConstDataKey, JSON.stringify({
    sessionId,
    timestamp: now,
    constData: constData
  }));
  return constData;
}

function generateSessionId() {
  return site + '_' + Date.now() + '_' + Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 9);
}

function getPlatform() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /mobile|android|iphone|ipad|tablet/i.test(userAgent);
  return isMobile ? 'mobile_web' : 'web';
}

function getOS() {
  const userAgent = navigator.userAgent;
  let os = 'Unknown';

  if (/Win/i.test(userAgent)) {
    os = userAgent.match(/Windows NT (\d+\.\d+)/)?.[1] || 'Windows';
    os = `Windows ${os}`;
  } else if (/Mac/i.test(userAgent)) {
    os = 'MacOS';
  } else if (/Android/i.test(userAgent)) {
    os = 'Android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    os = 'iOS';
  } else if (/Linux/i.test(userAgent)) {
    os = 'Linux';
  }

  return os;
}

function getBrowser() {
  const userAgent = navigator.userAgent;
  let browser = 'Unknown';

  if (/Edg/i.test(userAgent)) {
    browser = `Edge ${userAgent.match(/Edg\/(\d+)/)?.[1] || ''}`;
  } else if (/Chrome/i.test(userAgent) && !/Edg/i.test(userAgent)) {
    browser = `Chrome ${userAgent.match(/Chrome\/(\d+)/)?.[1] || ''}`;
  } else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    browser = `Safari ${userAgent.match(/Version\/(\d+)/)?.[1] || ''}`;
  } else if (/Firefox/i.test(userAgent)) {
    browser = `Firefox ${userAgent.match(/Firefox\/(\d+)/)?.[1] || ''}`;
  }

  return browser;
}

function getScreenResolution() {
  return `${window.screen.width}x${window.screen.height}`;
}

function getMD5Sign(input) {
  // 计算 MD5 并转换为大写
  const hash = CryptoJS.MD5(input).toString().toUpperCase();
  return hash;
}

// 并行获取异步数据
// const [ip, region] = await Promise.all([getIpAddress(), getDeviceInfo()]);
// const data = {
//   // "event_id": "",
//   "timestamp": Date.now(),
//   "session_id": getOrCreateSessionId(),
//   "user_id": "",
//   "device_info": {
//     "ip": ip,
//     "region": region,
//     "platform": getPlatform(),
//     "os": getOS(),
//     "browser": getBrowser(),
//     "screen": getScreenResolution(),
//   },
//   "site": site
//   // "page_info": {
//   //   "url": window.location.href,
//   //   "section": "",
//   //   "module": ""
//   // },
//   // "action": "",
//   // "details": {
//   //   "question_id": "",
//   //   "answers": [],
//   //   "records": [],
//   //   "results": [],
//   //   "element": "",
//   //   "target": "",
//   //   "variant_id": ""
//   // },
  
//   // "sign": ""
// }

/**
 * 深度合并两个对象。如果存在相同的键，第二个对象的值将覆盖第一个对象的值（对于非对象属性）或递归合并（对于对象属性）。
 *
 * @param {object} obj1 第一个要合并的对象。
 * @param {object} obj2 第二个要合并的对象。它的属性将覆盖或合并到第一个对象。
 * @returns {object} 一个新的合并后的对象。
 */
function deepMerge(obj1, obj2) {
  const result = {};

  // 复制第一个对象的所有属性
  for (const key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      result[key] = obj1[key];
    }
  }

  // 遍历第二个对象的属性并合并
  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (result.hasOwnProperty(key) && typeof result[key] === 'object' && result[key] !== null && typeof obj2[key] === 'object' && obj2[key] !== null) {
        // 如果两个属性都是对象，则递归合并
        result[key] = deepMerge(result[key], obj2[key]);
      } else {
        // 否则，用第二个对象的值覆盖第一个对象的值
        result[key] = obj2[key];
      }
    }
  }

  return result;
}

function getSign(data) {
  const signString = `action=${data.action}&event_id=${data.event_id}&session_id=${data.session_id}&site=${data.site}&timestamp=${data.timestamp}${data.user_id ? `&user_id=${data.user_id}` : '' }&key=${signKey}`;
  console.log('signString: ', signString);
  return getMD5Sign(signString);
}

// 合并数据
async function trackData(eventData, environment = 'online') {
  const constData = await getOrCreateTrackData();
  constData.timestamp = Date.now(); // 更新此次时间戳
  console.log('constData: ', constData);
  
  let mergedData = deepMerge(constData, eventData);
  mergedData.sign = getSign(mergedData);
  console.log('mergedData: ', mergedData);
    
  const path = '/user-data-server/v1/shopify-track-data';

  let url = `https://api-data-us-dcdn.mammotion.com${path}`

  if (environment === 'test' || Shopify?.theme?.role === 'unpublished') {
    url = `https://api-data-us-test.mammotion.com${path}`
  }

  
  // 发送数据
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mergedData),
      keepalive: true // 确保页面卸载时请求继续
    });
    
    // 检查响应是否成功
    if (!response.ok) {
      const errorData = await response.json();
      console.error("errorData:", errorData);
      return;
    }
    
    const data = await response.json();
    console.log("report result:", data);
    
    // const blob = new Blob([JSON.stringify(mergedData)], { type: 'application/json' });
    // console.log('Sending to:', url);
    // navigator.sendBeacon(url, blob);
    
  } catch (error) {
    console.error("Sending error:", error);
  }
}
